import { USER_MASK_UPDATE_TYPE, sanitizeTabulatorLayoutAttributes } from './tabulatorProgressiveLoading';

/**
 * Persistencia rozloženia Tabulator tabuľky (poradie + šírky stĺpcov).
 * getColumnLayout() vracia poradie, šírky a kópiu def. stĺpca (vrátane minWidth z času uloženia).
 * Pri obnovení z masky sa layout ukladá a aplikuje cez setColumnLayout(attributes) z uloženej masky.
 * Použitie: events={{ ...otherEvents, ...getTabulatorPersistLayoutEvents("PageName", ref, setUserMaskFilter) }}
 * Na stĺpcoch: minWidth (napr. 120) + widthGrow: 1 pri layout: "fitColumns" aby sa stĺpce roztiahli ale nezužili pod min.
 * movableColumns: true, resizable: true (default) – presúvanie a zmena šírky.
 */
export function getTabulatorPersistLayoutEvents(pageName, ref, setUserMaskFilter) {
  if (!setUserMaskFilter) return {};
  const save = () => {
    try {
      if (!ref?.current?.getColumnLayout) return;
      const layout = sanitizeTabulatorLayoutAttributes(ref.current.getColumnLayout());
      if (Array.isArray(layout) && layout.length > 0) {
        setUserMaskFilter(pageName, USER_MASK_UPDATE_TYPE.COLUMN_LAYOUT, null, null, layout);
      }
    } catch (_) {}
  };
  return {
    columnMoved: save,
    columnResized: save,
  };
}
